<template>
  <div class="civii-accordion">
    <div class="civii-accordion-block" v-for="(item, index) in items" :key="'menu'+index">
      <div class="civii-accordion-title"
        @click="itemSelected = index">
        <i class="civii-icon-arrow-right civii-tick"
          :class="{opened: itemSelected === index}" />
        {{item.title}}
      </div>
      <div v-show="itemSelected === index"
        class="civii-accordion-item"
        :class="{opened: itemSelected === index}">
        <slot name="item" :item="item" :selected="itemSelected === index"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: Array
  },
  data () {
    return {
      itemSelected: 0
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/Accordion/Accordion.vue